"use strict";

import * as React from 'react';
import { View } from 'react-native';
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(View, {
  ref: ref,
  accessibilityRole: "button",
  ...props
}));
//# sourceMappingURL=GestureHandlerButton.web.js.map